import { render, staticRenderFns } from "./AddShootingProgramTemplate.vue?vue&type=template&id=8ce940fc"
import script from "./AddShootingProgramTemplate.vue?vue&type=script&lang=js"
export * from "./AddShootingProgramTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports